import { CreditCardTypeEnum } from "./V2/gozer"

export const CreditCardTypes = [
    {
        name: "American Express",
        value: CreditCardTypeEnum.AMERICAN_EXPRESS
    },
    {
        name: "Discover",
        value: CreditCardTypeEnum.DISCOVER
    },
    {
        name: "Mastercard",
        value: CreditCardTypeEnum.MASTER_CARD
    },
    {
        name: "Visa",
        value: CreditCardTypeEnum.VISA
    },
    {
        name: "Not Defined",
        value: CreditCardTypeEnum.NOT_DEFINED
    }
]